import React from 'react';
import { Button } from 'tea-component';
import { connect, useIntl } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import SvgIcon from '@home/components/SvgIcon';
import { isSubVersion } from '@op/utils/game';
import BubbleCommon, {
  gptSubGameNotSupportTipsText,
  TipsMapType,
} from '@op/components/BubbleCommon';

function GptButton({
  disabled,
  onClick,
  className,
  extInfo,
  btnText = 'Get AI Summary',
  gameInfo,
  tipsMap,
  ...otherProps
}: {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  extInfo?: { [key: string]: any };
  btnText?: string;
  gameInfo?: any;
  tipsMap?: TipsMapType;
  [key: string]: any;
}) {
  const { formatMessage } = useIntl();
  const isSubGame = isSubVersion(gameInfo);
  return (
    <BubbleCommon
      showIcon={false}
      placement="top"
      tipsMap={isSubGame ? gptSubGameNotSupportTipsText : tipsMap || undefined}
    >
      <Button
        type="primary"
        className={`dbo-aigc-btn ${className}`}
        disabled={disabled || isSubGame}
        onClick={() => {
          onClick();
          buriedBtnPoint('GPT_Get_Btn', extInfo);
        }}
        {...otherProps}
      >
        {/* <img src={icon} className="dbo-aigc-icon" style={{ marginRight: 4 }} /> */}
        <SvgIcon
          type="robot-new"
          className="dbo-aigc-icon"
          style={{ marginRight: 4, color: '#fff' }}
        />
        {formatMessage({ id: btnText })}
      </Button>
    </BubbleCommon>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(GptButton);
